import StateMachine from "javascript-state-machine/lib/state-machine.js";
import StateMachineHistory from "javascript-state-machine/lib/history";
import FootballTransitionConfig from "./football-play-transitions";
import FootballState from "./football-state";

const stateConfig = {
    plugins: [new StateMachineHistory()],
    methods: {
        doTransition: function (transition) {
            this[transition]();
        }
    },
    data: {
        name: "Football"
    },
    init: FootballState.Start,
    transitions: FootballTransitionConfig,
    observeUnchangedState: true
};

const FootballPlayState = StateMachine.factory(stateConfig);

export default FootballPlayState;
